import type { MessageInteractionMode } from '../../types/MessageInteractionMode';

/**
 * Resolve the viewer's baseline message-interaction mode for a channel — the
 * membership half of PopshopRN's per-message mode derivation (the per-message
 * `deleted` half is applied at the bubble). The owner always interacts fully; a
 * non-broadcast channel needs active membership to react + reply; a broadcast
 * channel lets active members react but not reply (only the owner posts), and
 * everyone else is read-only until they join.
 */
export function resolveMessageInteractionMode(params: {
  isOwner: boolean;
  isBroadcastChannel: boolean;
  isMember: boolean;
}): MessageInteractionMode {
  const { isOwner, isBroadcastChannel, isMember } = params;
  if (isOwner) return 'normal';
  if (isBroadcastChannel) return isMember ? 'reaction-only' : 'readonly';
  return isMember ? 'normal' : 'readonly';
}
